import { memo } from 'react';
import { themeCssVar as theme } from '@tinderapp/ui-react';
import { IconFeatureVerifiedOverlay } from '@tinderapp/ui-react/es/icons';

import SvgIcon from './lib/SvgIcon';

const VerifiedIcon = (props: React.ComponentProps<typeof SvgIcon>) => (
  <IconFeatureVerifiedOverlay
    {...props}
    primary={theme.color.backgroundBadgeVerifiedDefault}
    tertiary={theme.color.white}
    quaternary={theme.color.white}
  />
);

VerifiedIcon.normalized = true;

export default memo(VerifiedIcon);
